import { addMember, disableMember, updateMember } from "./actions.js";
import {
    MILITARY_VARIANT,
    STC_VARIANT,
    refs,
    routePath,
} from "../../Database/_variants/index.js";
import {
    makeGrantDesignChangeAccess,
    makeRevokeDesignChangeAccess,
} from "./actions.js";

export default {
    "label": "Members",
    "key": "Members",
    "location": "CustomersUserdata/",
    "headers": [{
        "headerName": "Name",
        "field": "FullName"
    }, {
        "headerName": "Email",
        "field": "Email"
    }, {
        "headerName": "Enabled",
        "field": "Enabled",
        "type": "bool"
    }, {
        "headerName": "STC Design Items",
        "field": "Permissions.stc.DesignItems",
        "type": "bool"
    }, {
        "headerName": "STC Equipment Assessments",
        "field": "Permissions.stc.EquipmentAssessments",
        "type": "bool"
    }, {
        "headerName": "STC Design Queries",
        "field": "Permissions.stc.DesignQueries",
        "type": "bool"
    }, {
        "headerName": "Military Design Items",
        "field": "Permissions.military.DesignItems",
        "type": "bool"
    }, {
        "headerName": "Military Equipment Assessments",
        "field": "Permissions.military.EquipmentAssessments",
        "type": "bool"
    }, {
        "headerName": "Military Design Queries",
        "field": "Permissions.military.DesignQueries",
        "type": "bool"
    }],
    "actions": [{
        "label": "Add Member",
        "action": addMember
    }],
    "rowActions": [{
        "label": "Update Permissions",
        "action": updateMember
    }, {
        "label": "Disable Member",
        "action": disableMember
    }]
};

export const makeCustomerDesignChangesAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military Design Change" : "Design Change";
    const labelPlural = isMilitary ? "Military Design Changes" : "Design Changes";
    const designChangeRefs = refs(variant, "DesignChanges");

    return {
        "label": labelPlural,
        "key": `CustomerAccess.${variant.key}.DesignChanges`,
        computedData({ store, pageItem }) {
            return Object.values(store.state[designChangeRefs] || {}).filter(designChange =>
                designChange.CustomerAccess?.Enabled === true &&
                designChange.CustomerAccess?.CustomerID === pageItem.ID
            );
        },
        show({ store }) {
            return isMilitary
                ? store.state.user?.Security?.Military?.Read === true
                : store.state.user?.Security?.Database?.Read === true;
        },
        "headers": [{
            "headerName": "Number",
            "field": "Number"
        }, {
            "headerName": "Title",
            "field": "Title"
        }, {
            "headerName": "Type",
            "field": "Type"
        }, {
            "headerName": "Completed",
            "field": "Completed",
            "type": "bool"
        }],
        "actions": [{
            "label": `Add ${labelSingular}`,
            "action": makeGrantDesignChangeAccess(variant),
            show({ store }) {
                const databaseWrite = store.state.user?.Security?.Database?.Write === true;
                const militaryWrite = store.state.user?.Security?.Military?.Write === true;
                return [databaseWrite && (!isMilitary || militaryWrite), `Write access is required to add ${labelSingular} access`];
            }
        }],
        "rowActions": [{
            "label": `View ${labelSingular}`,
            action({ router, rowItem }) {
                router.push(`${routePath(variant, "DesignChanges")}/${rowItem.ID}`);
            }
        }, {
            "label": "Revoke Customer Access",
            "action": makeRevokeDesignChangeAccess(variant),
            show({ store }) {
                const databaseWrite = store.state.user?.Security?.Database?.Write === true;
                const militaryWrite = store.state.user?.Security?.Military?.Write === true;
                return [databaseWrite && (!isMilitary || militaryWrite), "Write access is required to revoke customer access"];
            }
        }]
    };
};

export const customerDesignChangesAttachable = makeCustomerDesignChangesAttachable(STC_VARIANT);
export const customerMilitaryDesignChangesAttachable = makeCustomerDesignChangesAttachable(MILITARY_VARIANT);
